<template>
  <v-row justify="center">
    <v-dialog
      v-model="value"
      persistent
      max-width="800px"
    >
      <v-toolbar color="primary" dark dense>
        <v-toolbar-title>Информация</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card>
        <v-card-text class=" black--text">
          {{message}}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            @click="onOKEvent"
          >
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  props: ['value', 'message'],
  methods: {
    onOKEvent () {
      this.$emit('onOK')
      this.$emit('input', false)
    }
  }
}
</script>
